<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="6">
                <v-row justify="center">
                    <v-col cols="8">
                      <page-heading v-if="false" :text="$t('views.orientation.title')"></page-heading>
                        <div style="position:absolute; right:0; text-align: right; width:70px">
                          <SectionButton show  v-demo-show="{event:'welcome.sidebar', show:false}"></SectionButton>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <v-row justify="center">
                          <MediaCompositionFramework max-height="60vh" :media-composition="comp" :autoplay="true" v-if="comp && !hide" @mediaReady="initiated=true"></MediaCompositionFramework>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-row justify="center">
                            <v-btn color="secondary"
                                   large
                                   v-if="initiated && !hide"
                                   @click="next()"
                            >{{$t('general.continue')}}
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PageHeading from "../../components/framework/PageHeading";
    import {ASSESSMENT_STATE_ORIENTATION} from '../../router/assessmentstate';
    import MediaCompositionFramework from '../../components/mediacomposition/MediaCompositionFramework'
    import SectionButton from "../../components/measure/question/section/SectionButton";
    export default {
        components: {
            PageHeading, MediaCompositionFramework,SectionButton
        },
        name: "OrientationVideo",
        data(){
          return {
            comp: null,
            hide : false,
            initiated : false,
          }
        },
        mounted(){
          this.comp = this.$store.state.journey.frameworkMediacompositions[1];
          setTimeout(()=>{
            this.initiated=true;
          },3000);
        },
        methods:{
          next(){
            this.hide=true;
            this.$nextTick(()=>{
              this.$store.dispatch('assessment/updateCurrentState',ASSESSMENT_STATE_ORIENTATION);
              this.$router.replace({name:'DeviceCheck'});
            });
          }
        }
    }
</script>

<style scoped>

</style>